import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import getLLMModel from 'common/src/modules/shared/copilot/models/utils/getLLMModel';
import {OpenAIModel} from 'common/src/modules/shared/copilot/openAI/openAI.enums';
import {OpenAIModelConfig} from 'common/src/modules/shared/copilot/openAI/openAI.models';

function getSetupAgentModel(): OpenAIModelConfig {
  const isGpt52Enabled = isFlagEnabled(FeatureFlagKey.EnableGpt5_2);

  const setupAgentModel = isGpt52Enabled
    ? getLLMModel(OpenAIModel.Gpt5_2)
    : getLLMModel(OpenAIModel.Gpt5_1);

  return setupAgentModel;
}

export default getSetupAgentModel;
